import React, { Component } from 'react';
import KYCContainer from '../KYCContainer/KYC';
import Reference from '../../../components/Reference/Reference';
import { FormHandler } from '../../../components/Reference/ReferenceFormHandler';
import { UserKycStatus } from '../../../common/userData/UserKycStatus';

class ReferenceContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pan: '',
      address: '',
      selfie: '',
      bank: '',
      custom: 'null',
      ref: '',
      loading: true
    };
  }

  // OnSubmit = () => {
  //   // FormHandler(this.props.componentHandler);
  // };
  onclick_handler = () => {};
  current_page = {
    pan: false,
    address: false,
    selfie: false,
    bank: false,
    ref: true
  };
  componentDidMount() {
    this.state.loading
      ? (this.setState({ loading: false }),
        UserKycStatus().then(res => {
          this.setState({
            pan: res.pan,
            address: res.aadhar,
            selfie: res.selfie,
            bank: res.bank,
            ref: res.ref,
            custom: 'null'
          });
        }))
      : null;
  }
  render() {
    return (
      <KYCContainer
        // data={this.state}
        curr_page={this.current_page}
        container={Reference}
        onclick_handler={this.onclick_handler}
        OnSubmit={this.OnSubmit}
        componentHandler={this.props.componentHandler}
      />
    );
  }
}
export default ReferenceContainer;
